<template>
<div>
    <b-table 
      striped 
      hover 
      selectable 
      select-mode="single" 
      @row-selected="onRowSelected" 
      :items="items" 
      :fields="fields" 
      :filter="filter"
      @filtered="onFiltered"
      :per-page="perPage"
      :current-page="currentPage">
    </b-table>

    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
</div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'

export default {
  components: { TablePagination },
  props: ['filter'],
  data() {
      return {
        perPage: 10,
        currentPage: 1,
        filteredRows: 0
      }
  },
  computed: {
    items() {
      return this.$store.state.userDataHandler.users.list;
    },
    fields() {
        return [
            { key: "id", label: this.$t('users.id'), sortable: true },
            { key: "name", label: this.$t('users.name'), sortable: false,
                formatter: (value, key, item) => {
                    return item.firstname + ' ' + item.lastname;
                }
            },
            { key: "organisation", label: this.$t('users.org'), sortable: true },
            { key: "group", label: this.$t('users.group'),  sortable: false,
                formatter: (value, key, item) => {
                    var s = "";
                    for( var g of item.usergroups ) {
                        if( s.length === 0 )
                            s = g.description;
                        else
                            s += ', ' + g.description;
                    }
                    return s;
                }
            }
        ];
    },
    totalRows() {
        return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
    }               
  },
  created() {
    this.$store.dispatch('userDataHandler/getUsers');
  },
  methods: {
    onRowSelected(items) {
      this.$emit('selectItem', items[0]);
    },
    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length;
      this.currentPage = 1
    },
    onPageChange(page){
      this.currentPage = page
    }
  }
}
</script>
